import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Lightbulb, Bullseye, ArrowRightCircle, Gem, Cpu, Briefcase, Award } from "react-bootstrap-icons";
import ai from "../assets/icons/ai.jpeg";
import "./Hakkimizda.css";

const Hakkimizda = () => {
  return (
    <div className="about-page">
      {/* 1. HERO SECTION */}
      <div className="about-hero-section">
        <Container>
          <h1 className="about-hero-title display-3">Dijital Dönüşümün Öncüsü</h1>
          <p className="about-hero-subtitle">
            STAİ BİLİŞİM olarak, hukuktan işletmeye, teknolojiyi hayatın merkezine taşıyarak
            geleceği bugünden tasarlıyoruz.
          </p>
        </Container>
      </div>

      {/* 2. MAIN CONTENT OFFSET CONTAINER */}
      <Container className="about-container">

        {/* STORY CARD */}
        <div className="story-card">
          <Row className="g-0 align-items-center">
            <Col lg={6} className="story-image-side" style={{ backgroundImage: `url(${ai})` }}>
              {/* Image Background */}
            </Col>
            <Col lg={6}>
              <div className="story-text-side">
                <div className="story-label">HİKAYEMİZ</div>
                <h2 className="story-heading">Teknoloji ile İnsanı Buluşturuyoruz</h2>
                <p className="story-text">
                  Teknoloji, insan yaşamını kolaylaştıran en güçlü araçtır. İlk çağlardan bugüne süregelen
                  bu gelişim yolculuğunda, <strong>STAİ BİLİŞİM</strong> olarak biz de yerimizi alıyoruz.
                </p>
                <p className="story-text">
                  Hukuk ofislerinden kurumsal işletmelere kadar geniş bir yelpazede, teknoloji tabanlı
                  dönüşümlere liderlik ediyoruz. AR-GE odaklı yaklaşımımızla, sadece bugünün değil,
                  yarının ihtiyaçlarına da cevap veren yazılım çözümleri geliştiriyoruz.
                </p>
                <div className="mt-4">
                  <Link to="/İletisim" className="cta-button">
                    <span>Bizimle Tanışın</span>
                    <ArrowRightCircle size={20} />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* VALUES GRID */}
        <div className="values-section">
          <Row className="g-4">
            <Col md={4}>
              <div className="value-box">
                <div className="value-icon-box"><Bullseye size={50} /></div>
                <h3 className="value-heading">Misyonumuz</h3>
                <p className="value-description">
                  Modern teknolojileri kullanarak insan odaklı, hızlı ve verimli çözümler üretmek;
                  iş süreçlerini dijitalleştirerek katma değer sağlamak.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="value-box">
                <div className="value-icon-box"><Lightbulb size={50} /></div>
                <h3 className="value-heading">Vizyonumuz</h3>
                <p className="value-description">
                  Global standartlarda yazılım teknolojileri üreterek, sektörde öncü, güvenilir
                  ve yenilikçi bir teknoloji üssü olmak.
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="value-box">
                <div className="value-icon-box"><Gem size={50} /></div>
                <h3 className="value-heading">Değerlerimiz</h3>
                <p className="value-description">
                  Şeffaflık, sürekli gelişim, müşteri odaklılık ve etik çalışma prensipleriyle
                  hareket ederek topluma fayda sağlamak.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        {/* STATS SECTION */}
        <div className="stats-section">
          <Row className="justify-content-center g-5">
            <Col md={4}>
              <div className="stat-item">
                <Cpu size={40} className="text-primary mb-3" />
                <div className="stat-number">AR-GE</div>
                <div className="stat-label">Odaklı Yaklaşım</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="stat-item">
                <Briefcase size={40} className="text-primary mb-3" />
                <div className="stat-number">%100</div>
                <div className="stat-label">Müşteri Memnuniyeti</div>
              </div>
            </Col>
            <Col md={4}>
              <div className="stat-item">
                <Award size={40} className="text-primary mb-3" />
                <div className="stat-number">Lider</div>
                <div className="stat-label">Sektörel Çözümler</div>
              </div>
            </Col>
          </Row>
        </div>

      </Container>
    </div>
  );
};

export default Hakkimizda;